export default "__VITE_ASSET__46775559__"